import React from "react";

const Arithmetic = () => {
  return (
    <div>
      <h1>Arithmetic Component</h1>
      <p>Content for Arithmetic goes here...</p>
    </div>
  );
};

export default Arithmetic;
